/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { KeeperRewardL2 } from "./KeeperRewardL2";

export class KeeperRewardL2Factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<KeeperRewardL2> {
    return super.deploy(overrides || {}) as Promise<KeeperRewardL2>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): KeeperRewardL2 {
    return super.attach(address) as KeeperRewardL2;
  }
  connect(signer: Signer): KeeperRewardL2Factory {
    return super.connect(signer) as KeeperRewardL2Factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): KeeperRewardL2 {
    return new Contract(address, _abi, signerOrProvider) as KeeperRewardL2;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "keeper",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "func",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
    ],
    name: "KeeperCalled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_perpToken",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IAmm",
        name: "_amm",
        type: "address",
      },
    ],
    name: "payFunding",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4[]",
        name: "_funcSelectors",
        type: "bytes4[]",
      },
      {
        internalType: "address[]",
        name: "_contracts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_rewardAmount",
        type: "uint256[]",
      },
    ],
    name: "setKeeperFunctions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    name: "tasksMap",
    outputs: [
      {
        internalType: "address",
        name: "contractAddr",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "rewardAmount",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
